export const SPOUSE_AGES = Array.from({ length: 21 }, (_, index) => index + 25)
